import script from "./AssetsByLocationReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetsByLocationReport.vue?vue&type=script&setup=true&lang=js"

import "./AssetsByLocationReport.vue?vue&type=style&index=0&id=148e0da0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-148e0da0"]])

export default __exports__